export default __webpack_public_path__ + "static/media/assessment_glide_7_1.35e09b7a.svg";